@if (tableData && tableData[retailMailOrderSwitch]) {
  <div class="mat-typography mat-body mat-app-background">
    <div class="costTableContainer">
      <table class="costTable">
        @if (tableData[retailMailOrderSwitch].monthly.hasTopper) {
          <tr>
            @for (topper of tableData[retailMailOrderSwitch].monthly.tableTop; track topper; let index = $index) {
              <th>
                {{topper}}
              </th>
            }
          </tr>
        }
        <tr class="costHeading">
          <th></th>
          @for (header of tableData[retailMailOrderSwitch].monthly.headerRow; track header; let index = $index) {
            <th>
              {{header}}
            </th>
          }
        </tr>
        @for (monthRow of tableData[retailMailOrderSwitch].monthly.tableBody; track monthRow; let index = $index) {
          <tr>
            <td>{{monthLabels[index] }}</td>
            @for (detailCell of monthRow.row; track detailCell; let index = $index) {
              <td [innerHTML]="detailCell">
              </td>
            }
          </tr>
        }
      </table>
    </div>
  </div>
}
